// (A) 중립 Descriptions API — antd 미접촉. (B) PlainDescriptions/PlainDescriptionsItem 에 위임.
// antd Descriptions / Descriptions.Item 복합을 OmwDescriptions + OmwDescriptionsItem 으로 분리.
import type { CSSProperties, ReactNode } from 'react'
import { PlainDescriptions, PlainDescriptionsItem } from '../_impl/PlainDescriptions'

export interface OmwDescriptionsProps {
  size?: 'small' | 'default' | 'middle'
  column?: number
  /** 셀 테두리(→ antd Descriptions bordered). 실측: ninegqlUI detail. */
  bordered?: boolean
  title?: ReactNode
  extra?: ReactNode
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export interface OmwDescriptionsItemProps {
  label?: ReactNode
  className?: string
  children?: ReactNode
}

export function OmwDescriptions(props: OmwDescriptionsProps) {
  return <PlainDescriptions {...props} />
}

export function OmwDescriptionsItem(props: OmwDescriptionsItemProps) {
  return <PlainDescriptionsItem {...props} />
}
